var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3063 61H1.11279V53.5L10.3063 45.0323V38.9839L1.11279 36.5645V29.3065L29.1773 1H52.887V9.22581L44.1773 17.8591V24.9516H52.887V33.1774L25.3063 61Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11279 29.3065C19.4999 29.1129 24.9031 29.2258 25.3063 29.3065M1.11279 29.3065V36.5645L10.3063 38.9839V45.0323M1.11279 29.3065L29.1773 1H52.887M25.3063 29.3065V37.0484M25.3063 29.3065L52.887 1M25.3063 37.0484L16.3547 38.9839V51.3226M25.3063 37.0484L44.1773 17.8591M16.3547 51.3226L25.3063 53.5M16.3547 51.3226L44.1773 24.9516M25.3063 53.5V61M25.3063 53.5L52.887 24.9516M25.3063 61H1.11279V53.5M25.3063 61L52.887 33.1774V24.9516M1.11279 53.5L10.3063 51.3226V45.0323M1.11279 53.5L10.3063 45.0323M52.887 1V9.22581L44.1773 17.8591M44.1773 17.8591V24.9516M44.1773 24.9516H52.887",
    stroke: "#006D77",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector36);
export default __webpack_public_path__ + "static/media/Vector 36.c60a367b8cb6f914cc588a094c8db35a.svg";
export { ForwardRef as ReactComponent };